// extracted by mini-css-extract-plugin
module.exports = {"checkbox-inputs":"checkbox-module__checkbox-inputs___1B1CV","checkboxInputs":"checkbox-module__checkbox-inputs___1B1CV"};